<template>
  <div class="welcomeContainer">
   

     
    <div class="text-body-1 rubikRegularFont"> 
      <p class="rubikRegularFont"> {{ bodyText1Bind }}</p>
      <p class="rubikRegularFont"> {{ bodyText2Bind }} </p>
      <p class="rubikRegularFont"> {{ bodyText3Bind }} </p>
    </div>
    <div class="mt-4" v-if="textAnimationFinished">
      <v-btn @click="$emit(`nextStep`)" class="nextBtn"> Got it ! </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeTextContainer',
  data: () => ({
      textAnimationFinished : false,
      welcomeText : `Welcome,`,
      bodyText1 : `Let me introduce myself.`,
      bodyText2 : `I’m Ismail El Asri, a full-stack software engineer.`,
      bodyText3 : `I design and build complete digital products — from backend architecture to interactive front-end experiences. I enjoy taking ideas from concept to production and delivering scalable, user-focused solutions.`,
      welcomeTextBind : ``,
      bodyText1Bind : ``,
      bodyText2Bind : ``,
      bodyText3Bind : ``,

  }),
  async mounted(){
    await this.animateWelcomeText();
    await this.animateBodyTexts();
    await this.sleep(100);
    this.textAnimationFinished =  true;
  },
  methods : {
    async animateWelcomeText(){
      for (let i = 0; i <= this.welcomeText.length - 1; i += 1) {
        await this.sleep(100);
        this.welcomeTextBind += `${this.welcomeText[i]}`;
      }
    },
    async animateBodyTexts(){
      for (let i = 0; i <= this.bodyText1.length - 1; i += 1) {
        await this.sleep(15);
        this.bodyText1Bind += `${this.bodyText1[i]}`;
      }
      for (let i = 0; i <= this.bodyText2.length - 1; i += 1) {
        await this.sleep(15);
        this.bodyText2Bind += `${this.bodyText2[i]}`;
      }
      for (let i = 0; i <= this.bodyText3.length - 1; i += 1) {
        await this.sleep(15);
        this.bodyText3Bind += `${this.bodyText3[i]}`;
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

  }
}
</script>

<style scoped>

.welcomeContainer{
  margin-top:100px;
  border-radius: 5px;
  padding: 10px;
  font-size: 27px;
}

</style>
